import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useEffect } from 'react';
import { Circle } from 'react-leaflet';
import { useGeolocated } from 'react-geolocated';
import './user-location-marker.sass';
import { blockUpdateWhileMoving } from 'shared/map/ui/components/marker/rotated/lib/block_moving';
import { RotatedMarker } from '../model/rotated-marker';
import { a2l } from 'shared/map/lib/utils';
import { useCompass } from 'shared/map/lib/compass';
const RotatedUserMarker = memo(function RotatedUserMarker(props) {
    const { heading, coords } = props;
    if (heading)
        return (_jsx(RotatedMarker, { position: a2l([coords.longitude, coords.latitude]), icon_class: "ui-location-header-user", icon_width: 70, icon_height: 46, icon_anchor: [35, 38.5], angle: heading, zIndexOffset: 1000 }));
    else if (![-1, null, undefined].includes(coords.heading))
        return (_jsx(RotatedMarker, { position: a2l([coords.longitude, coords.latitude]), icon_class: "ui-location-header-user", icon_width: 70, icon_height: 46, icon_anchor: [35, 38.5], angle: coords.heading, zIndexOffset: -1000 }));
    else
        return (_jsx(RotatedMarker, { position: a2l([coords.longitude, coords.latitude]), icon_class: "ui-location-user", icon_width: 15, icon_height: 15, icon_anchor: [7.5, 7.5], zIndexOffset: -1000 }));
});
const UserLocationMarker = (props) => {
    const { onSuccess } = props;
    const { coords, isGeolocationAvailable, isGeolocationEnabled, getPosition } = useGeolocated({
        positionOptions: {
            enableHighAccuracy: true,
            maximumAge: 45000,
            timeout: 30e3,
        },
        watchPosition: true,
        suppressLocationOnMount: true,
        geolocationProvider: {
            getCurrentPosition(successCallback, errorCallback, options) {
                return navigator.geolocation.getCurrentPosition(successCallback, errorCallback, options);
            },
            watchPosition(successCallback, errorCallback, options) {
                return navigator.geolocation.watchPosition(successCallback, errorCallback, options);
            },
            clearWatch(watchId) {
                return navigator.geolocation.clearWatch(watchId);
            },
        },
        onSuccess: (position) => {
            onSuccess?.(position.coords);
        },
    });
    useEffect(() => {
        getPosition();
    }, []);
    const heading = useCompass();
    if (!isGeolocationAvailable) {
        return null;
    }
    if (!isGeolocationEnabled) {
        return null;
    }
    if (!coords) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(RotatedUserMarker, { heading: heading, coords: coords }), coords.accuracy != null && (_jsx(Circle, { center: a2l([coords.longitude, coords.latitude]), radius: coords.accuracy, color: "#3388FF", fillOpacity: 0.1, opacity: 0.1, stroke: false }))] }));
};
export const OrientatedUserLocationMarker = memo(blockUpdateWhileMoving(UserLocationMarker));
